import EventDeletionModal, { IEventDeletionModalProps } from './EventDeletionModal'

export default EventDeletionModal
export { IEventDeletionModalProps }
